import style from "css/address.module.css";
import GroupTag from './groupTag';
import MoreIcon from './moreIcon';

function AddressCard({ info, tagList, deleteAddress, checkBoxHandler, openData, isLastCard }) {
    return (
        <div className={style.addrCard_wrapper}>
            <div className={style.addrCard_container} >
                <input type='checkbox' className={style.addrCard_checkbox} onChange={checkBoxHandler} value={info.key} />
                <div className={style.addr_info}>
                    <div className={style.addr_info_1}>
                        <div className={style.addr_name}>
                            {info.name}
                            {
                                info.tag?.length > 0 &&
                                info.tag.map(el => {
                                    const tag = tagList.find(item => item.label === el);
                                    return tag ? <GroupTag key={el} tag={tag} /> : null;
                                })
                            }
                        </div>
                        <MoreIcon
                            info={info}
                            deleteAddress={deleteAddress}
                            openData={openData}
                            isLastCard={isLastCard}
                        />
                    </div>
                    <div className={style.addr_info_2}>
                        {info.email}
                        <div className={style.addr_v_seperator}></div>
                        {info.tel}
                    </div>
                </div>

            </div>
        </div>
    )
}

export default AddressCard
